import React from 'react';
import PropTypes from 'prop-types';
import { TrackingProvider as BaseTrackingProvider } from '@g4/next-furniture/analytics';

import { useSSRQuery } from '../../graphql';

import TAG_MANAGER_QUERY from './trackingProvider/tagManager.query.graphql';

const propTypes = {
  children: PropTypes.node,
};

const TrackingProvider = ({ children }) => {
  const { loading, error, data } = useSSRQuery(TAG_MANAGER_QUERY);
  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  const { googleTagManagerId } = data.application.configurations;

  return (
    <BaseTrackingProvider
      googleTagManagerId={googleTagManagerId}
      children={children}
    />
  );
};

TrackingProvider.propTypes = propTypes;

export default TrackingProvider;
